<template>
  <div class="partner-benefits-box">
    <h4 class="partner-benefits-box__title">
      {{ t('partner.registration.form.step1.benefits.title') }}
    </h4>
    <ul class="partner-benefits-box__list">
      <li
        v-for="(benefit, index) in benefits"
        :key="index"
        class="partner-benefits-box__item"
      >
        <CheckGeneric class="partner-benefits-box__icon" />
        <span>{{ benefit }}</span>
      </li>
    </ul>
  </div>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n'
import CheckGeneric from '~/assets/icons/check-generic.svg?component'

const { t } = useI18n()

const benefits = computed(() => [
  t('partner.registration.form.step1.benefits.reachCustomers'),
  t('partner.registration.form.step1.benefits.easyManagement'),
  t('partner.registration.form.step1.benefits.marketingSupport'),
])
</script>

<style lang="postcss" scoped>
.partner-benefits-box {
  @apply bg-teal-50 rounded-lg p-4 border border-gray-200;
}

.partner-benefits-box__title {
  @apply text-base font-semibold text-gray-900 mb-3;
}

.partner-benefits-box__list {
  @apply space-y-2;
}

.partner-benefits-box__item {
  @apply flex items-center gap-2 text-sm text-gray-700;
}

.partner-benefits-box__icon {
  @apply text-teal-600 flex-shrink-0;
  width: 16px;
  height: 16px;
}
</style>
